<template>
  <div class="page-project-description p-top-m-1 p-bottom-m-1">
    <!-- Info -->
    <div class="page-project-description__info">
      <div class="page-project-description__info__row">
        <h2>{{ $t('projects.tags.industry') }}</h2>
        <!-- Industry -->
        <PagesProjectTagList
          v-if="props.project.industryTag?.length"
          :tags="props.project.industryTag"
          :query="'industry'"
        />
      </div>
      <div class="page-project-description__info__row">
        <h2>{{ $t('projects.tags.technology') }}</h2>
        <!-- Technology -->
        <PagesProjectTagList
          v-if="props.project.technologyTag?.length"
          :tags="props.project.technologyTag"
          :query="'technology'"
        />
      </div>
    </div>
    <!-- Content -->
    <div
      v-html="props.project.textContent"
      class="page-project-description__content m-top-l-1"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'PagesProjectDescription',
}
</script>

<script setup>
const props = defineProps({
  project: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
